import { TeamLeaguePlayerPhotoDto } from '@/infrastructure/network/dto/PlayerPhotoDto';

export enum TeamLeaguePlayerStatus {
	TEAM_PLAYER = 'TEAM_LEAGUE_TEAM_PLAYER',
	TEAM_CAPTAIN = 'TEAM_LEAGUE_TEAM_CAPTAIN',
	TEAM_CAPTAIN_ASSISTANCE = 'TEAM_LEAGUE_TEAM_CAPTAIN_ASSISTANCE'
}

export enum ApproveDeclineStatusEnum {
	PLAYER_TRANSFER_APPROVAL_STATUS_UNDEFINED = 'PLAYER_TRANSFER_APPROVAL_STATUS_UNDEFINED',
	PLAYER_TRANSFER_APPROVAL_STATUS_PENDING = 'PLAYER_TRANSFER_APPROVAL_STATUS_PENDING',
	PLAYER_TRANSFER_APPROVAL_STATUS_APPROVED = 'PLAYER_TRANSFER_APPROVAL_STATUS_APPROVED',
	PLAYER_TRANSFER_APPROVAL_STATUS_DECLINED = 'PLAYER_TRANSFER_APPROVAL_STATUS_DECLINED'
}

export enum PlayerTransferRequestType {
	ADD = 'PLAYER_TRANSFER_TYPE_ADD',
	JOIN = 'PLAYER_TRANSFER_TYPE_JOIN',
	MOVE = 'PLAYER_TRANSFER_TYPE_MOVE',
	TRADE = 'PLAYER_TRANSFER_TYPE_TRADE',
	DELETE = 'PLAYER_TRANSFER_TYPE_DROP',
	REPLACE = 'PLAYER_TRANSFER_TYPE_REPLACE'
}

interface PlayerInfo {
	uuid: string;
	fullname: string;
	phone: string;
	internationalCallingCode: string;
	payment: number;
	playerUuid?: string;
	skinnySingles: number | null;
	ratingSingles: number;
	ratingDoubles: number;
	ratingOption: 'RATING_DUPR' | 'RATING_WPR' | 'RATING_UNDEFINED';
}
export interface TeamPlayerInfo extends PlayerInfo {
	thumbnail: string | null;
	status: string | TeamLeaguePlayerStatus;
	availability?: string;
	designation?: string | number;
	sendTextAlerts: boolean;
	isInjured: boolean;
	actions?: string;
}
export interface ActivityPlayerInfoData extends PlayerInfo {
	transferType: PlayerTransferRequestType;
	isCompleted: boolean;
	isApprovedByCommissioner: ApproveDeclineStatusEnum;
	isApprovedByTeam: ApproveDeclineStatusEnum;
	isApprovedByPlayer: ApproveDeclineStatusEnum;
	userUuid: string;
	photo: TeamLeaguePlayerPhotoDto;
	sendTextAlerts: boolean;
	transferRequestUuid: string;
	playerUuid?: string;
	status?: string | TeamLeaguePlayerStatus;
	transferRequestDateCreated: string;
	transferRequestDateUpdated?: string | null;
}
